import { Alert, Typography, AlertProps, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import ConsultRequestTable from "../ConsultRequestTable/ConsultRequestTable";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import { RequestData } from "../../Request/useRequestData";

interface ConsultEquivalencyResultProp {
  requestData: RequestData
}
const ConsultEquivalencyResult: React.FC<ConsultEquivalencyResultProp> = ({ requestData }) => {
  const { t } = useTranslation();

  const {
    equivalencies,
    target_syllabus: targetSyllabus,
  } = requestData;

  return (
    <Grid
      item
      xs={12}
      lg={5.5}
      height={"inherit"}
      className="REQXXI-Grid-Paper"
      mr={"10px"}
      sx={{ width: { xs: "100%" } }}
    >
      <div className="REQXXI-Request-Accordion" style={{ height: "100%" }}>
        <div
          className="REQXXI-Block-Container"
          style={{ height: "100%", borderRadius: "20px" }}
        >
          {targetSyllabus ? (
            <>
              {!!equivalencies && equivalencies.length > 0 ? (
                <ConsultRequestTable rules={equivalencies} />
              ) : (
                <Alert
                  color={"primary" as AlertProps["color"]}
                  severity="info"
                  style={{ margin: "16px", background: "#FFF" }}
                >
                  {t("equivalencyConsultEmptySimulation")}
                </Alert>
              )}
            </>
          ) : (
            <Grid
              item
              height={"inherit"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Typography align="center">
                <>
                  <TouchAppIcon
                    style={{ fontSize: "5rem" }}
                    color="secondary"
                  />
                  <br />
                  <br />
                  {t("simulateEquivalences")}
                </>
              </Typography>
            </Grid>
          )}
        </div>
      </div>
    </Grid>
  );
}
export default ConsultEquivalencyResult;